
import Vue from "vue";
import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";
import adminTitlingService from "@/services/admin/titlingService";
import lookupsService from "@/services/admin/lookupsService";
import { ProgramLookupInfo } from "@/types/admin/Lookup";
import { MetaNames } from "@/constants";

export default Vue.extend({
  components: { ReportViewer },
  name: "CertPrinting",
    data: function () {
        return {
            title: MetaNames.AdminCertificatePrinting,
            Report_Name: '',
            Report_URL: '',
            Report_Cert_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
            Report_CertFull_Name: 'Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx',
            Report_Labels_Name: 'Asca.Api.Reports.rpt1210_Person_Label.rdlx',
            showReportDialog: false,
            certType: "",
            showMarkPrintedDialog: false,
            snackbar: false,
            snackbarColor: "green",
            snackbarText: "",
            luItems: [] as ProgramLookupInfo[],
        };
    },
  created: function () {
    this.reloadItems();
  },
  methods: {
    showTitleDialog: function (){   
      this.Report_Name = this.Report_Cert_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted`;
      this.showReportDialog = true;
    },
    showTitleDialogFull: function (){
      this.Report_Name = this.Report_CertFull_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted`;
      this.showReportDialog = true;
    },
    showLabelsDialog: function (){
      this.Report_Name = this.Report_Labels_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted/contacts`;
      this.showReportDialog = true;
    },
    reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getCertProgramList().then((res: ProgramLookupInfo[]) => {
                this.luItems = res.filter(p => p.isManual);
                this.$data.isLoading = false;

            });
            this.$data.isLoading = false;
        },
    toggleMarkPrintedDialog() {
      this.showMarkPrintedDialog = !this.showMarkPrintedDialog;
    },
    markUnprintedAsPrinted() {
      this.toggleMarkPrintedDialog();
      adminTitlingService
        .markUnprintedCertsPrinted(this.certType)
        .then((res) => {
            if (res.success) {
                this.snackbar = true;
                this.snackbarText = "Successfully marked certificates as printed";
                this.snackbarColor = "green";
            } else {
                this.snackbar = true;
                this.snackbarText = "Error occured while trying to mark certificates as printed";
                this.snackbarColor = "red";   
            }
        })
        .catch((e) => {
            console.error(e);
            this.snackbar = true;
            this.snackbarText = "Error occured while trying to mark certificates as printed";
            this.snackbarColor = "red";   
        });
    },
  },
  watch: {
    showReportDialog(newVal: boolean) {
      if (!newVal) {
        this.showMarkPrintedDialog = true;
      }
    },
  },
});
